import http from '@/utils/http'
// import { HomeReq, HomeRes, CarouselReq, CarouselRes } from './types/other'
import { IBusinessQueryVO } from './types'

/**
 * 首页接口
 */
const homeApi = {

  // 获取轮播
  getCarousel(CarouselReq: any) {
    return http.post<any>('/business/advertisement/getAdvertisement', CarouselReq)
  },

  // 获取首页数据
  getHome() {
    return http.post<any>('/business/floor/getFloorList', {})
  },
  
}
export default homeApi